import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  outerRow:{ width: "90%", float: "left", display:'flex',flexDirection:'row',justifyContent:'space-between', margin:'10px 5%' },
  textField:{width:'300px'},
  label:{margin:'5px 0px', color:'grey', fontWeight:'bold'}
}));

export default useStyles;
